import { render, staticRenderFns } from "./TextareaBlock.vue?vue&type=template&id=4cf387e2&"
import script from "./TextareaBlock.vue?vue&type=script&lang=js&"
export * from "./TextareaBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports